import pixAxios from '@/axios/pixAxios.js';
import Vue from 'vue';
import _ from 'lodash';
import store from '@/store';
import pixEvaluateUtils from '@/services/common/pixEvaluate.utils.js';
import paramListProvider from '@/apiProviders/paramList.provider.js';
import appIdParameter from '@/consts/appIdParameterConfig.const.js';
import certificationProvider from '@/apiProviders/certification.provider';
import tableIdConst from '@/consts/tableId.const';

const GENERIC_FORM_BUSINESS_MODULES = {
  1: 'AssetModule',
  9: 'UnitValModule',
  10: 'PortfolioModule',
  11: 'ValuationModule',
  12: 'StatutoryRecordModule',
};

const _getLeaseBaseRentTableViolatedConstraints = (tableRows) => {
  const violatedConstraints = [];
  // A comp should not be created if the Ending Month of a base rent is previous to its Starting Month
  const someEndingMonthsArePreviousToTheirStartingPoints = tableRows.some((tableRow) => tableRow.EndingMonth < tableRow.StartingMonth);
  if (someEndingMonthsArePreviousToTheirStartingPoints) {
    violatedConstraints.push('baseRent.warningMonthConstraint');
  }
  return violatedConstraints;
};

export default {
  getKeyModuleByFormId(formId) {
    return GENERIC_FORM_BUSINESS_MODULES[formId];
  },

  setExplicitWidthToVueMultiselect(doc) {
    const objs = doc.getElementsByClassName('multiselect');
    for (let i = 0; i < objs.length; i = i + 1) {
      const eltoWitdh = document.getElementsByClassName('multiselect')[i].offsetWidth;
      doc.getElementsByClassName('multiselect__content-wrapper')[i].style.width = `${eltoWitdh}px !important`;
    }
  },

  hasMandatoryFieldsFilled(form) {
    const missingFields = form.formData.filter(({ IsMandatory, Value }) => {
      return IsMandatory && (Value === null || Value === undefined || Value === '');
    });
    return missingFields;
  },

  getFilteredByConditions(form, model = null) {
    return {
      ...form,
      formData: form?.formData?.filter((control) => !control.Conditions || pixEvaluateUtils.evalConditions(control.Conditions, model, null, form)),
    };
  },

  getExtraInfoError(formConfig, extraInfo, mandatoryMsg, typeMsg) {
    let mandatoriesMsg = null;
    let typesMsg = null;
    if (extraInfo.mandatoryNonFilled) {
      mandatoriesMsg = `${mandatoryMsg}<br/>`;
      _.forEach(extraInfo.fN_MandatoryNonFilled, (elem) => {
        try {
          mandatoriesMsg += `${_.find(formConfig, (x) => x.InternalField === elem.split(' ')[0]).Label + (_.indexOf(elem, ' ') === -1 ? '' : _.slice(elem, _.indexOf(elem, ' '), elem.length))}<br/>`;
        } catch (e) {
          mandatoriesMsg += `${elem}<br/>`;
        }
      });
    }
    if (!extraInfo.typesChecked) {
      typesMsg = `${typeMsg}<br/>`;
      _.forEach(extraInfo.fN_TypeNonSuit, (elem) => {
        try {
          typesMsg += `${_.find(formConfig, (x) => x.InternalField === elem).Label}<br/>`;
        } catch (e) {
          typesMsg += `${elem}<br/>`;
        }
      });
    }
    if (mandatoriesMsg || typesMsg) {
      return `${mandatoriesMsg === null ? '' : mandatoriesMsg}<br/>${typesMsg === null ? '' : typesMsg}`;
    }
    return '';
  },

  getValueByInternalField(form, internalField) {
    return form?.find(({ InternalField }) => InternalField === internalField)?.Value;
  },

  getValueDescFromSelectControl(form, internalField) {
    const control = form?.find(({ InternalField }) => InternalField === internalField);
    return control?.ParamListValues?.find(({ ValueCode }) => ValueCode === control?.Value)?.ValueDesc ?? control?.Value;
  },

  getGenericFormCall(formId, forceCall = false, { fullInstance: instance, langCode = 'en', appId = appIdParameter.PIX } = store.getters) {
    const params = {
      appId,
      formId,
      instance: instance ?? store.getters['authModule/fullInstance'],
      langCode,
    };
    const form = store.getters['genericConfigModule/getGenericFormConfigById'](formId);
    return !forceCall && form
      ? Promise.resolve(_.cloneDeep(form))
      : pixAxios.post('/api/GenericConfig/GetForm', params).then(({ data }) => {
          /**
           * Esto es necesario para aplicar las transformaciones que se hacen desde los EmitEventName.
           * Vue.set() lanza las computadas y los watchers del componente padre de los genericForm si
           * se añade una propiedad que no existía originalmente en el objeto de configuración.
           */
          const formConfig = data?.map((control) => ({ ...control, shouldTransform: control.FieldControlType === 'input' && control.EmitEventName }));

          store.dispatch('genericConfigModule/setGenericFormConfig', { genericFormConfig: _.cloneDeep(formConfig), formId });
          return formConfig;
        });
  },

  getParamListFromDB(name, instance) {
    const SET_PARAM_LIST_FROM_DB = {
      CERTIFICATIONS_USERS: () => this.getParamsListValuesCertificationsScope(instance),
      GET_USERS_LIST: () => this.getParamListValuesFromGetUsersByInstance(instance),
    };

    return SET_PARAM_LIST_FROM_DB[name]();
  },

  assignDefaultValueToInitEventNameField(control) {
    const setDefaultValueByInitEventNameValue = {
      GET_USERS_LIST: () => this.setDefaultValueForOriginatedByField(control),
    };

    return setDefaultValueByInitEventNameValue[control.InitEventName] && setDefaultValueByInitEventNameValue[control.InitEventName](control);
  },

  getParamsListValuesCertificationsScope(instance) {
    const params = {
      InstanceRol: instance,
      rows: 9999,
    };

    return certificationProvider.searchCertificationSection(params).then(({ rows }) => {
      return rows.map(({ AudTime, AudUsu, InstanceRol, RowId, AppraiserCode, AppraiserName, ValueOrder }) => {
        return {
          AudTime,
          AudUsu,
          InstanceRol,
          RowId,
          ValueCode: AppraiserCode,
          ValueDesc: AppraiserName,
          ValueOrder,
        };
      });
    });
  },

  getParamListValuesFromGetUsersByInstance(instance) {
    return paramListProvider.getUsersByInstance(instance).then((response) => {
      return response.map(({ UserRowId, UserName, UserId }, index) => {
        return {
          AudTime: null,
          AudUsu: null,
          InstanceRol: instance,
          RowId: UserRowId,
          ValueCode: UserId,
          ValueDesc: UserName,
          ValueOrder: index,
        };
      });
    });
  },

  setDefaultValueForOriginatedByField(control) {
    if (!control.Value) {
      Vue.set(control, 'Value', store.getters['authModule/lowerCasedUserName']);
    }
  },

  checkFormsInvalid(forms = []) {
    for (const form of forms) {
      if (form?.formData?.find((field) => field.IsMandatory && !field.Value)) {
        return true;
      }
    }
    return false;
  },

  getTablesViolatedConstraints(tablesConfig, tableRows, form) {
    const violatedConstraints = [];

    for (const tableConfig of tablesConfig) {
      switch (tableConfig.ComponentId) {
        case tableIdConst.RESEARCH_LEASE_BASE_RENT:
          violatedConstraints.push(..._getLeaseBaseRentTableViolatedConstraints(tableRows[tableIdConst.RESEARCH_LEASE_BASE_RENT]));
          break;
        default:
          break;
      }
    }

    return violatedConstraints;
  },
};
